// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--1aXxz","inner":"_80ad21f8ef--inner--2veLU"};